export const roundUpToTwoDecimalPlace = (res: number) =>
  (Math.ceil(res * 100) / 100).toFixed(2)
